import { PlusIcon, FlagIcon } from "@heroicons/react/20/solid"
import mobilityIcon from 'media/icons/mobility.png'

export default function KinesisProgramWeekKeyIcon({ 
    displaySize = 'small',
    programWeekKey 
}) {
    if (displaySize === 'small') {
        return (
            <div className="flex flex-col items-center justify-center h-5 w-5">

                {programWeekKey === 'load-increase' &&
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path 
                            d="M9 2.5C9.3806 2.5 9.73638 2.70485 9.92068 3.03325L15.5076 12.9158C15.8161 13.4629 15.4133 14.125 14.7621 14.125H3.23785C2.5867 14.125 2.18395 13.4629 2.49241 12.9158L8.07932 3.03325C8.26362 2.70485 8.6194 2.5 9 2.5Z" 
                            fill="#99a1af"
                        />
                    </svg>
                }

                {programWeekKey === 'volume-increase' &&
                    <PlusIcon className="w-5 h-5 text-gray-400" />
                }

                {programWeekKey === 'maintain' &&
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <polygon 
                            points="9,3 15,9 9,15 3,9" 
                            fill="#99a1af" 
                        />
                    </svg>
                }

                {(
                    programWeekKey === 'deload' ||
                    programWeekKey === 'deload-override'
                ) && 
                    <div className="-mt-1 scale-90">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <polygon points="0,0 0,16 16,16" fill="#99a1af" />
                            <line x1="0" y1="0" x2="16" y2="16" stroke="white" strokeWidth="1.5" />
                        </svg>
                    </div>
                }

                {programWeekKey === 'event-deload-override' && 
                    <FlagIcon className="w-4 h-4 pb-0.5 text-gray-400" />
                }

                {(
                    programWeekKey === 'range-of-motion' ||
                    programWeekKey === 'dynamic-movement'
                ) &&
                    <img src={mobilityIcon} alt="Mobility" className="w-5 h-5 opacity-40" />
                }

                {(
                    programWeekKey !== 'load-increase' 
                    && programWeekKey !== 'volume-increase'
                    && programWeekKey !== 'maintain'
                    && programWeekKey !== 'deload'
                    && programWeekKey !== 'deload-override'
                    && programWeekKey !== 'event-deload-override'
                    && programWeekKey !== 'range-of-motion'
                    && programWeekKey !== 'dynamic-movement'
                    && programWeekKey !== 'none'
                ) &&
                    <div className="text-xxs text-center text-gray-600">{programWeekKey}</div>
                }
            </div>
        )
    }

    if (displaySize === 'large') {
        return (
            <div className="flex flex-col items-center justify-center h-8 w-8">

                {programWeekKey === 'load-increase' &&
                    <svg width="27" height="27" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path 
                            d="M9 2.5C9.3806 2.5 9.73638 2.70485 9.92068 3.03325L15.5076 12.9158C15.8161 13.4629 15.4133 14.125 14.7621 14.125H3.23785C2.5867 14.125 2.18395 13.4629 2.49241 12.9158L8.07932 3.03325C8.26362 2.70485 8.6194 2.5 9 2.5Z" 
                            fill="#99a1af"
                        />
                    </svg>
                }

                {programWeekKey === 'volume-increase' &&
                    <PlusIcon className="w-8 h-8 text-gray-400" />
                }

                {programWeekKey === 'maintain' &&
                    <svg width="27" height="27" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <polygon 
                            points="9,3 15,9 9,15 3,9" 
                            fill="#99a1af" 
                        />
                    </svg>
                }

                {(
                    programWeekKey === 'deload' ||
                    programWeekKey === 'deload-override'
                ) && 
                    <div className="-mt-1.5 scale-90">
                        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <polygon points="0,0 0,16 16,16" fill="#99a1af" />
                            <line x1="0" y1="0" x2="16" y2="16" stroke="white" strokeWidth="1.5" />
                        </svg>
                    </div>
                }

                {programWeekKey === 'event-deload-override' && 
                    <FlagIcon className="w-7 h-7 pb-0.5 text-gray-400" />
                }

                {(
                    programWeekKey === 'range-of-motion' ||
                    programWeekKey === 'dynamic-movement'
                ) &&
                    <img src={mobilityIcon} alt="Mobility" className="w-8 h-8 opacity-40" />
                }

                {(
                    programWeekKey !== 'load-increase' 
                    && programWeekKey !== 'volume-increase'
                    && programWeekKey !== 'maintain'
                    && programWeekKey !== 'deload'
                    && programWeekKey !== 'deload-override'
                    && programWeekKey !== 'event-deload-override'
                    && programWeekKey !== 'range-of-motion'
                    && programWeekKey !== 'dynamic-movement'
                    && programWeekKey !== 'none'
                ) &&
                    <div className="text-xs text-center text-gray-600">{programWeekKey}</div>
                }
            </div>
        )
    }
}